<!-- ALERT TOAST-->
<p-toast></p-toast>
<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Cargando ... </span>
</div>

<!-- MAIN CARD-->
<div class="card">
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- DYNAMIC TABLE -->
    <p-table #dt [columns]="cols" [value]="data" [paginator]="true" [rows]="rowsPerPage"
        currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
        [showCurrentPageReport]="true" responsive="true" [globalFilterFields]="colsGlobal">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <!-- MAIN TITLE-->
                <h5>{{titlePage}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>
            <span class="p-input-icon-left">
                <button pButton pRipple pTooltip="{{lbl_new}}" icon="pi pi-plus" class="p-mr-4 z-5"
                    (click)="createData()"></button>
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{ capitalizeLastElement(col.header) }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                <th>
                    Opciones
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{ getNestedValue(rowData, col.field) }}
                </td>
                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editData(rowData)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{ lbl_total }} {{ data ? data?.length : 0 }} {{ lbl_records }}.
            </div>
        </ng-template>
    </p-table>
</div>